export const inputDebounceDelay = 750;
export const defaultPageSize = 25;
